/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_No_Spaces_Yet_TitleInputs */



/**
* | output |
* | --- |
* | "No spaces yet" |
*
* @param {Spaces_No_Spaces_Yet_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_no_spaces_yet_title = /** @type {((inputs?: Spaces_No_Spaces_Yet_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_No_Spaces_Yet_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Spaces")
	return /** @type {LocalizedString} */ ("No spaces yet")
});